import { render } from "./ProcessInfo.vue?vue&type=template&id=91b54282&scoped=true"
import script from "./ProcessInfo.vue?vue&type=script&lang=js"
export * from "./ProcessInfo.vue?vue&type=script&lang=js"

import "./ProcessInfo.vue?vue&type=style&index=0&id=91b54282&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b54282"]])

export default __exports__